__turbopack_context__.v({
  "button": "GRWFXG_button",
  "buttonRecommended": "GRWFXG_buttonRecommended",
  "buttonSelected": "GRWFXG_buttonSelected",
  "buttonSelectedRecommended": "GRWFXG_buttonSelectedRecommended",
  "buttonWrapper": "GRWFXG_buttonWrapper",
  "recommendationText": "GRWFXG_recommendationText",
  "wrapper": "GRWFXG_wrapper",
});
